// frontend/src/pages/dashboard/riskView.js
import React from 'react';

// 单条逐人行（可选档位标签 register；class 逐人视图不传 → 不显档名）
function PersonLine({ register, name, position, score, threshold, text }) {
  return (
    <div className="dash-risk">
      <div className="dash-risk__hd">
        <span className="dash-risk__who">{register ? `${register} · ` : ''}{name || '—'}{position ? `（${position}）` : ''}</span>
        {score != null && (
          <span className="dash-risk__meta">
            {score}{threshold != null ? ` / 阈值 ${threshold}` : ''}
          </span>
        )}
      </div>
      {text ? <div className="dash-risk__bd">{text}</div> : null}
    </div>
  );
}

// 群像名单（紧凑，姓名+分数 chip）
function MemberChips({ members }) {
  return (
    <div className="dash-risk__chips">
      {(members || []).map((m, i) => (
        <span key={i} className="dash-risk__chip">{m.display_name} {m.score}</span>
      ))}
    </div>
  );
}

export function DimensionRisk({ dim, scopeKind }) {
  // 三态契约：不同 scope 只带对应结构；所有数组读取走兜底，缺 key 不崩（缓存/灰度/空维度）
  const entries = dim.entries || [];
  const bands = dim.bands || [];
  return (
    <div className="dash-card">
      <div className="dash-sec">
        <h2>{dim.dim_name}</h2>
        <span className="dash-mut">{dim.affected ?? 0}/{dim.total ?? 0} 人存在短板</span>
      </div>

      {scopeKind === 'class' && (
        <div className="dash-risk__list">
          {entries.map((e, i) => (
            <PersonLine key={i} name={e.student?.display_name} position={e.student?.position}
              score={e.score} threshold={e.threshold} text={e.text} />
          ))}
        </div>
      )}

      {scopeKind === 'enterprise_noclass' && (
        <div className="dash-risk__list">
          {bands.map((b, i) => (
            b.kind === 'single' ? (
              <PersonLine key={i} register={b.register} name={b.member?.display_name} position={b.member?.position}
                score={b.score} threshold={b.threshold} text={b.text} />
            ) : (
              <div key={i} className="dash-risk dash-risk--cohort">
                <div className="dash-risk__hd">
                  {/* 标题 = 档位名 + 得分区间 + 人数（每档独立成段） */}
                  <span className="dash-risk__who">{b.register} · 得分 {b.score_min}–{b.score_max} · {b.size} 人</span>
                </div>
                <div className="dash-risk__bd">{b.text}</div>
                <MemberChips members={b.members} />
              </div>
            )
          ))}
        </div>
      )}

      {scopeKind === 'enterprise_class' && (
        <div className="dash-risk__bd">{dim.enterprise_text}</div>
      )}
    </div>
  );
}
